import React from 'react';
import PageHeader from '../../../components/PageHeader';

export const SubscribedUserPayamentTitle = ({ navigationData, activeMainTab, onTabClick }) => {
	return (
		<PageHeader
			header="Billing"
			navigationData={navigationData || []}
			showMainTabs={!!(navigationData && navigationData.length > 0)}
			activeMainTab={activeMainTab}
			onTabClick={onTabClick}
		/>
	);
};
